import React from 'react';
import classNames from 'classnames';
import { ThemeMode } from '../../hooks/useThemeMode';

type LogoProps = {
    mode?: ThemeMode;
    variant?: 'main' | 'icon';
    className?: string;
};

export default function Logo({
    mode = 'light',
    variant = 'main',
    className,
}: LogoProps) {
    const isDark = mode === 'dark';

    const logoSrc =
        variant === 'main'
            ? isDark
                ? '/TYI_ICON_LOCKUP_CREAM.svg'
                : '/green-logo.png'
            : isDark
            ? '/TYI_ICON_CREAM.png'
            : '/TYI_ICON_GREEN.png';

    return (
        <img
            src={logoSrc}
            className={classNames(
                variant === 'main' ? 'h-10 w-auto max-w-[190px] object-contain' : 'h-10 w-auto max-w-10 object-contain',
                className
            )}
            alt="Track Your Impact logo"
        />
    );
}
